import { AppTheme } from '@meitu/saas-ui/es/theme';
import { getLocaleStore } from '@/i18n';
import { IEnhanceSlider } from '../types';
import particleDarkWrapBackgroundImage from './assets/dark/particle-bg.jpg';
import particleLightWrapBackgroundImage from './assets/light/particle-bg.jpg';

export const getSliderConfig = (theme = AppTheme.white) => {
    const { $t } = getLocaleStore();

    return [
        {
            featureType: 'particulars',
            name: $t((v) => v.mainLayer.enhance.config.vignette),
            keyName: 'vignette',
            maxVal: 100,
            minVal: -100,
            lightBackgroundClass: 'ab_2',
            lightWrapBackgroundClass: 'aj_2',
            darkBackgroundClass: 'ab_2',
            darkWrapBackgroundClass: 'aj_2',
        },
        {
            featureType: 'particulars',
            name: $t((v) => v.mainLayer.enhance.config.particle),
            keyName: 'particle',
            maxVal: 100,
            minVal: 0,
            lightBackgroundClass: 'ks_1',
            lightWrapBackgroundClass: particleLightWrapBackgroundImage,
            darkBackgroundClass: 'ks_1',
            darkWrapBackgroundClass: particleDarkWrapBackgroundImage,
        },
        {
            featureType: 'particulars',
            name: $t((v) => v.mainLayer.enhance.config.dispersion),
            keyName: 'dispersion',
            maxVal: 100,
            minVal: 0,
            lightBackgroundClass: 'ks_1',
            lightWrapBackgroundClass: 'ss_2',
            darkBackgroundClass: 'ks_1',
            darkWrapBackgroundClass: 'ss_2',
        },
    ].map((item: IEnhanceSlider) => {
        theme = theme === AppTheme.dark ? AppTheme.dark : AppTheme.white;
        //底层背景
        item.background =
            theme == 'dark'
                ? item.darkBackgroundClass
                    ? { useStyle: true, classname: item.darkBackgroundClass }
                    : item.darkBackgroundImage
                : item.lightBackgroundClass
                  ? { useStyle: true, classname: item.lightBackgroundClass }
                  : item.lightBackgroundImage;

        //蒙版背景
        item.wrapBackground =
            theme == 'dark'
                ? item.darkWrapBackgroundClass
                    ? { useStyle: true, classname: item.darkWrapBackgroundClass }
                    : item.darkWrapBackgroundImage
                : item.lightWrapBackgroundClass
                  ? { useStyle: true, classname: item.lightWrapBackgroundClass }
                  : item.lightWrapBackgroundImage;
        return item;
    });
};
